import React from 'react';
import { ThemeIcon } from '@24i/nxg-sdk-quarks';
import { StyledButton } from '../../Button';
export const PrevNextEpisodeButton = ({ onPress, direction, disabled, playerInstance, }) => {
    const iconToUse = direction === 'prev' ? 'onPrimary-control_skipPrevious' : 'onPrimary-control_skipNext';
    const onPressHandler = () => {
        if (disabled)
            return;
        onPress(direction);
    };
    const stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };
    return (React.createElement(StyledButton, { width: 24, heigth: 24, onClick: onPressHandler, onDoubleClick: stopPropagation, disabled: disabled, playerInstance: playerInstance, backgroundColor: "transparent" },
        React.createElement(ThemeIcon, { size: 24, iconName: iconToUse, iconStyles: { opacity: disabled ? 0.4 : 1 } })));
};
//# sourceMappingURL=index.js.map